import type { LocaleMessageBundle } from '../../types'

export const accountProfileMessages: LocaleMessageBundle = {
  vi: {
    'auth.profile.title': 'Thông tin tài khoản',
    'auth.profile.subtitle': 'Cập nhật thông tin cá nhân của tài khoản đang đăng nhập',
    'auth.profile.sections.avatar': 'Ảnh đại diện',
    'auth.profile.sections.account': 'Thông tin đăng nhập',
    'auth.profile.sections.personal': 'Thông tin cá nhân',
    'auth.profile.fields.employeeCode': 'Mã nhân viên',
    'auth.profile.fields.username': 'Tên đăng nhập',
    'auth.profile.fields.tenant': 'Đơn vị',
    'auth.profile.fields.branch': 'Chi nhánh hiện tại',
    'auth.profile.fields.roles': 'Vai trò',
    'auth.profile.fields.status': 'Trạng thái',
    'auth.profile.status.active': 'Hoạt động',
    'auth.profile.status.inactive': 'Tạm ngưng',
    'auth.profile.fields.fullName': 'Họ tên',
    'auth.profile.fields.email': 'Email',
    'auth.profile.fields.phone': 'Số điện thoại',
    'auth.profile.fields.gender': 'Giới tính',
    'auth.profile.fields.birthday': 'Ngày sinh',
    'auth.profile.fields.address': 'Địa chỉ',
    'auth.profile.gender.male': 'Nam',
    'auth.profile.gender.female': 'Nữ',
    'auth.profile.actions.chooseAvatar': 'Chọn ảnh',
    'auth.profile.actions.removeAvatar': 'Xóa ảnh',
    'auth.profile.actions.changePassword': 'Đổi mật khẩu',
    'auth.profile.actions.save': 'Lưu thay đổi',
    'auth.profile.hints.readonly': 'Mã nhân viên và tên đăng nhập do quản trị viên quản lý.',
    'auth.profile.hints.avatar': 'JPG, PNG hoặc WebP, tối đa 5MB.',
    'auth.profile.hints.minimumAge': 'Nhân viên phải đủ ít nhất {age} tuổi.',
    'auth.profile.empty.branch': 'Chưa có chi nhánh',
    'auth.profile.empty.roles': 'Chưa có vai trò',
    'auth.profile.empty.value': 'Chưa cập nhật',
    'auth.profile.success.updated': 'Thông tin tài khoản đã được cập nhật.',
    'auth.profile.errors.sessionMissing': 'Không tìm thấy phiên đăng nhập hiện tại.',
    'auth.profile.errors.updateFailed': 'Không thể cập nhật thông tin tài khoản.',
    'auth.profile.errors.avatarUploadFailed': 'Không thể tải ảnh đại diện lên.',
    'auth.profile.errors.avatarDeleteFailed': 'Không thể xóa ảnh đại diện.',
    'auth.profile.errors.avatarType': 'Ảnh đại diện phải là JPG, PNG hoặc WebP.',
    'auth.profile.errors.avatarSize': 'Ảnh đại diện không được vượt quá 5MB.',
  },
  en: {
    'auth.profile.title': 'Account information',
    'auth.profile.subtitle': 'Update the personal information for the signed-in account',
    'auth.profile.sections.avatar': 'Profile picture',
    'auth.profile.sections.account': 'Sign-in information',
    'auth.profile.sections.personal': 'Personal information',
    'auth.profile.fields.employeeCode': 'Employee code',
    'auth.profile.fields.username': 'Username',
    'auth.profile.fields.tenant': 'Organization',
    'auth.profile.fields.branch': 'Current branch',
    'auth.profile.fields.roles': 'Roles',
    'auth.profile.fields.status': 'Status',
    'auth.profile.status.active': 'Active',
    'auth.profile.status.inactive': 'Inactive',
    'auth.profile.fields.fullName': 'Full name',
    'auth.profile.fields.email': 'Email',
    'auth.profile.fields.phone': 'Phone number',
    'auth.profile.fields.gender': 'Gender',
    'auth.profile.fields.birthday': 'Birthday',
    'auth.profile.fields.address': 'Address',
    'auth.profile.gender.male': 'Male',
    'auth.profile.gender.female': 'Female',
    'auth.profile.actions.chooseAvatar': 'Choose image',
    'auth.profile.actions.removeAvatar': 'Remove image',
    'auth.profile.actions.changePassword': 'Change password',
    'auth.profile.actions.save': 'Save changes',
    'auth.profile.hints.readonly': 'Employee code and username are managed by an administrator.',
    'auth.profile.hints.avatar': 'JPG, PNG, or WebP, up to 5MB.',
    'auth.profile.hints.minimumAge': 'Staff must be at least {age} years old.',
    'auth.profile.empty.branch': 'No branch assigned',
    'auth.profile.empty.roles': 'No roles assigned',
    'auth.profile.empty.value': 'Not provided',
    'auth.profile.success.updated': 'Account information has been updated.',
    'auth.profile.errors.sessionMissing': 'The current sign-in session could not be found.',
    'auth.profile.errors.updateFailed': 'Unable to update account information.',
    'auth.profile.errors.avatarUploadFailed': 'Unable to upload the profile picture.',
    'auth.profile.errors.avatarDeleteFailed': 'Unable to remove the profile picture.',
    'auth.profile.errors.avatarType': 'The profile picture must be JPG, PNG, or WebP.',
    'auth.profile.errors.avatarSize': 'The profile picture must not exceed 5MB.',
  },
}
